import React from 'react';
import './Engagement.css';
import { toSentenceCase } from '../utils/textUtils';

function Engagement() {
  const values = [
    {
      icon: (
        <svg width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6"/>
          <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18"/>
          <path d="M4 22h16"/>
          <path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22"/>
          <path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22"/>
          <path d="M18 2H6v7a6 6 0 0 0 12 0V2Z"/>
        </svg>
      ),
      title: toSentenceCase('Excellence'),
      description: toSentenceCase('Nous visons l\'excellence dans tous les domaines de l\'éducation.')
    },
    {
      icon: (
        <svg width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
          <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
        </svg>
      ),
      title: toSentenceCase('Discipline'),
      description: toSentenceCase('La discipline est la base de tout succès académique et personnel.')
    },
    {
      icon: (
        <svg width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="12" cy="12" r="10"/>
          <line x1="2" y1="12" x2="22" y2="12"/>
          <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
        </svg>
      ),
      title: toSentenceCase('Ouverture'),
      description: toSentenceCase('Nous préparons les élèves à être des citoyens du monde.')
    }
  ];

  return (
    <section className="engagement section">
      <div className="container">
        <h2 className="section-title">{toSentenceCase("Notre engagement")}</h2>
        <p className="section-subtitle">
          {toSentenceCase("Depuis plus de 06 ans, nous nous engageons à offrir une éducation de qualité supérieure, alliant excellence académique, formation du caractère et ouverture sur le monde. Notre mission est de former des citoyens responsables, créatifs et compétents pour relever les défis de demain.")}
        </p>

        <div className="values-grid">
          {values.map((value, index) => (
            <div key={index} className="value-card">
              <div className="value-icon">{value.icon}</div>
              <h3>{value.title}</h3>
              <p>{value.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Engagement;
